import React from "react";
import DeleteIcon from "../../../../../icons/DeleteIcon";
import EditIcon from "../../../../../icons/EditIcon";
import FolderIcon from "../../../../../icons/FolderIcon";
// import FileMoveItem from "../../../../../icons/FileMoveItem";
import { Link } from "react-router-dom";
const FolderItem = ({
    folder,
    onDelete=()=>{},
    onEdit=()=>{},
    // onMove=()=>{}
})=>{
    return(
        <div className='library-folder-item'>
            <Link to={`/library/${folder._id}-${folder.name}`} className='info-data'>
                <FolderIcon/>
                <p>{folder.name}</p>
            </Link>
            <div className='action-btns'>
                <button onClick={onDelete}><DeleteIcon/></button>
                <button onClick={onEdit}><EditIcon/></button>
                {/* <button><FileMoveItem/></button> */}
            </div>
        </div>
    )
}
export default FolderItem;